import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Context } from "./types/xapi";

type XapiSlice = {
  userContext?: Context;
};

const initialState: XapiSlice = {};

export const xapiSlice = createSlice({
  name: "xapiSlice",
  initialState,
  reducers: {
    setContext: (state, action: PayloadAction<Context>) => {
      return {
        ...state,
        userContext: action.payload
      };
    }
  }
});

export const { actions: xapiActions } = xapiSlice;
